export const organisationRoutes = {
  hub: 'organisation/hub',
  settings: 'organisation/settings'
};
